module.exports = __webpack_public_path__ + "img/camera-angles.1642b784.png";